import React from 'react'
import {Button, Card, CardBody, Col, Form, FormGroup, Input, Row} from "reactstrap";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {common_strings} from "../../translations/common_translations";
import ResourceApiService from "../../api/resource-api-service";
import resourceHelper from "../../helpers/ResourceHelper";

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const propTypes = {};

class EditRoomView extends React.Component {
    handleChange = this.handleChange.bind(this);

    constructor(props) {
        super(props);
        this.state = {
            room: props.room || resourceHelper.emptyRoom(),
            inputsUpdated: true,
            validation: {
                name: true,
            }
        };

        this.getLocales = this.getLocales.bind(this);
        this.getLocales()
    }

    handleChange(event) {

        let newValue = event.target.value;
        let targetId = event.target.id;
        let checkBoxValue = event.target.checked;

        switch (targetId) {
            case "input-name":
                this.setState(prevState => ({
                    room: {
                        ...prevState.room,
                        name: newValue
                    }
                }));
                break;
            case "input-capacity":
                this.setState(prevState => ({
                    room: {
                        ...prevState.room,
                        capacity: newValue
                    }
                }));
                break;
            case "input-main-cb":
                this.setState(prevState => ({
                    room: {
                        ...prevState.room,
                        is_main: checkBoxValue
                    }
                }));
                break;
            case "input-note":
                this.setState(prevState => ({
                    room: {
                        ...prevState.room,
                        note: newValue
                    }
                }));

                break;

            case "input-address":
                this.setState(prevState => ({
                    room: {
                        ...prevState.room,
                        address: newValue
                    }
                }));

                break;
            default:
                return
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.room !== this.props.room) {
            this.setState({
                room: nextProps.room,
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.room !== this.state.room) {
            this.handleValidation();
        }
    }

    updateRoom(e) {
        e.preventDefault();

        if (this.validationCleared()) {
            this.setState({isLoading: true});

            if (this.state.room.id) {
                ResourceApiService.updateRoom(this.state.room)
                    .then(res => {
                        this.setState({
                            isLoading: false
                        });

                        this.props.closeEditRoomView()
                    })
                    .catch((e) => {
                        this.props.handleError(e)
                    });
            } else {
                ResourceApiService.postRoom(this.state.room)
                    .then(res => {
                        this.setState({
                            isLoading: false
                        });

                        this.props.closeEditRoomView()
                    })
                    .catch((e) => {
                        this.props.handleError(e)
                    });
            }
        }
    }

    render() {
        this.localize();

        return (
            <Card className="bg-secondary shadow">
                <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                        {this.state.room &&
                        <div className="pl-lg-4">
                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-start"
                                        >
                                            {resourceStrings.title}
                                        </label>
                                        <Input
                                            placeholder={resourceStrings.title}
                                            className={this.state.validation.name === true ? "form-control-alternative" : "is-invalid"}
                                            onChange={this.handleChange}
                                            defaultValue={this.state.room.name}
                                            id="input-name"
                                            type="name"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-capacity"
                                        >
                                            {resourceStrings.capacity}
                                        </label>
                                        <Input
                                            placeholder={resourceStrings.capacity}
                                            onChange={this.handleChange}
                                            defaultValue={this.state.room.capacity}
                                            id="input-capacity"
                                            type="number"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-note"
                                        >
                                            {commonStrings.note}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            id="input-note"
                                            placeholder={commonStrings.note}
                                            onChange={this.handleChange}
                                            defaultValue={this.state.room && this.state.room.note ? this.state.room.note : ''}
                                            rows="3"
                                            type="textarea"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            {/*<Row>*/}
                            {/*    <Col lg="12">*/}
                            {/*        <FormGroup>*/}
                            {/*            <label*/}
                            {/*                className="form-control-label"*/}
                            {/*                htmlFor="input-address"*/}
                            {/*            >*/}
                            {/*                {commonStrings.address}*/}
                            {/*            </label>*/}
                            {/*            <Input*/}
                            {/*                className="form-control-alternative"*/}
                            {/*                id="input-address"*/}
                            {/*                placeholder={commonStrings.address}*/}
                            {/*                onChange={this.handleChange}*/}
                            {/*                defaultValue={this.state.room && this.state.room.address ? this.state.room.address : ''}*/}
                            {/*                rows="3"*/}
                            {/*                type="address"*/}
                            {/*            />*/}
                            {/*        </FormGroup>*/}
                            {/*    </Col>*/}
                            {/*</Row>*/}

                            <Row>
                                <Col lg="12">
                                    <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="input-main-cb"
                                            onChange={this.handleChange}
                                            checked={this.state.room.is_main && this.state.room.is_main === true}
                                            type="checkbox"
                                        />
                                        <label className="custom-control-label" htmlFor="input-main-cb">
                                            {resourceStrings.main_room}
                                        </label>
                                        <div>
                                            <small>{resourceStrings.main_room_expl}</small>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            {this.state.locales && this.state.locales.length > 1 &&
                            <span style={{marginTop: 20}}>
                                <label>{commonStrings.business.locale}</label>
                                <div style={{display: "flex", flexFlow: "row"}}>
                                    {this.state.locales.map((locale, index) => {
                                        return (
                                            <Button
                                                size="sm"
                                                onClick={e => this.setLocale(e, locale)}
                                                key={locale.id.toString() + "w"} style={{
                                                paddingLeft: 10,
                                                paddingRight: 10,
                                                backgroundColor: locale.id == this.state.room.locale_id ? "#e86565" : "#e0cccc",
                                                borderRadius: 8,
                                                fontSize: "0.8rem",
                                                margin: 4,
                                                display: "flex",
                                                flexFlow: "column",
                                            }}>
                                                <div>{locale.title}</div>
                                                <div
                                                    style={{
                                                        fontSize: "0.6rem",
                                                        color: "white"
                                                    }}>{locale.address ? locale.address.street : ""}</div>
                                            </Button>
                                        )
                                    })}
                                </div>
                            </span>
                            }

                        </div>
                        }

                        <Row>
                            <Col lg="12">
                                <Col className="text-right">
                                    <Button
                                        color="warning"
                                        disabled={!this.validationCleared()}
                                        outline="button"
                                        size="lg"
                                        onClick={e => this.props.closeEditRoomView(e)}
                                    >
                                        {commonStrings.close}
                                    </Button>

                                    <Button
                                        color={this.validationCleared() ? "default" : "secondary"}
                                        disabled={!this.validationCleared()}
                                        size="lg"
                                        onClick={e => this.updateRoom(e)}
                                    >
                                        {commonStrings.save}
                                    </Button>
                                </Col>
                            </Col>
                        </Row>

                    </Form>
                </CardBody>
            </Card>
        )
    }

    setLocale(e, locale) {
        if (e) e.preventDefault();

        this.setState(prevState => ({
            room: {
                ...prevState.room,
                locale_id: locale ? locale.id : null
            }
        }));
    }


    validateName() {

        const name = this.state.room.name || "";

        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                name: name.length >= 2
            }
        }));
    }

    handleValidation() {
        this.validateName();
    }

    validationCleared() {
        return Object.values(this.state.validation).every(item => item)
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    getLocales() {
        this.setState({isLoading: true})
        ResourceApiService.loadLocales()
            .then(res => {
                this.setState({locales: res})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            })
            .finally(() => this.setState({isLoading: false}));
    }
}

EditRoomView.propTypes = propTypes;

export default EditRoomView;